// Stripe configuration for Neurocademy subscription plans
export interface StripePriceConfig {
  monthly: string;
  yearly: string;
}

export interface StripeProductConfig {
  productId: string;
  prices: StripePriceConfig;
}

export const STRIPE_CONFIG: Record<string, StripeProductConfig> = {
  parent_plan: {
    productId: import.meta.env.VITE_STRIPE_PRODUCT_PARENT_PLAN || '',
    prices: {
      monthly: import.meta.env.VITE_STRIPE_PRICE_PARENT_PLAN_MONTHLY || '',
      yearly: import.meta.env.VITE_STRIPE_PRICE_PARENT_PLAN_YEARLY || '',
    },
  },
  family_plan: {
    productId: import.meta.env.VITE_STRIPE_PRODUCT_FAMILY_PLAN || '',
    prices: {
      monthly: import.meta.env.VITE_STRIPE_PRICE_FAMILY_PLAN_MONTHLY || '',
      yearly: import.meta.env.VITE_STRIPE_PRICE_FAMILY_PLAN_YEARLY || '',
    },
  },
  school_starter: {
    productId: import.meta.env.VITE_STRIPE_PRODUCT_SCHOOL_STARTER || '',
    prices: {
      monthly: import.meta.env.VITE_STRIPE_PRICE_SCHOOL_STARTER_MONTHLY || '',
      yearly: import.meta.env.VITE_STRIPE_PRICE_SCHOOL_STARTER_YEARLY || '',
    },
  },
  // lifetime_promo: Handled server-side only for security
};

export const STRIPE_PUBLISHABLE_KEY = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY || '';

// Validate that all Stripe configuration is present
export function validateStripeConfig(): boolean {
  if (!STRIPE_PUBLISHABLE_KEY) {
    console.error('Missing VITE_STRIPE_PUBLISHABLE_KEY environment variable');
    return false;
  }

  for (const [planId, config] of Object.entries(STRIPE_CONFIG)) {
    if (!config.productId) {
      console.error(`Missing product ID for plan: ${planId}`);
      return false;
    }
    if (!config.prices.monthly) {
      console.error(`Missing monthly price ID for plan: ${planId}`);
      return false;
    }
    if (!config.prices.yearly) {
      console.error(`Missing yearly price ID for plan: ${planId}`);
      return false;
    }
  }

  return true;
}

// Get Stripe price ID for a plan and interval
export function getStripePriceId(planId: string, interval: 'monthly' | 'yearly'): string | null {
  const config = STRIPE_CONFIG[planId];
  if (!config) {
    console.error(`Unknown plan ID: ${planId}`);
    return null;
  }

  return interval === 'yearly' ? config.prices.yearly : config.prices.monthly;
}